import { useLayoutStore } from 'shared/hooks/stores/useLayoutStore';
import { useScrollBooleanToggle } from 'shared/hooks/useScrollBooleanToggle';
import { useShallow } from 'zustand/react/shallow';

export const useTopbarHidden = () => {
  const { setTopbarHidden, topbarHidden } = useLayoutStore(
    useShallow((store) => ({
      topbarHidden: store.topbarHidden,
      setTopbarHidden: store.setTopbarHidden,
    })),
  );

  useScrollBooleanToggle(setTopbarHidden);

  return topbarHidden;
};
